export default __webpack_public_path__ + "static/media/startup.d2dc296a.svg";